var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5c-2.205 0-4 1.795-4 4s1.795 4 4 4 4-1.795 4-4-1.795-4-4-4z",
    opacity: 0.161
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.476 13c-2.924 0-5.397 1.981-6.198 4.746.452.267 1.02.896 1.703 1.887a3 3 0 0 1 .199.33c.391.762.658 1.44.799 2.037h7.734A2.287 2.287 0 0 0 29 19.713C29 16.01 26.047 13 22.476 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.03 16C6.634 16 3 19.68 3 24.204A2.796 2.796 0 0 0 5.796 27h10.408A2.796 2.796 0 0 0 19 24.204C19 19.68 15.425 16 11.03 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z",
    opacity: 0.161
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulGroup);
export default __webpack_public_path__ + "static/media/icons-colorful-group.4ef1542e.svg";
export { ForwardRef as ReactComponent };